import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import { $isAuth, setIsAuth } from '../../store/isAuthStore';
import Cookies from 'universal-cookie';
import { useUnit } from 'effector-react';
import Icon, { LogoutOutlined, StarFilled, ReadFilled } from "@ant-design/icons";
import { setUserData, setUserDataLoaded } from '../../store';
import { isMobile } from "react-device-detect"
import { ReactComponent as hammerFinish } from "../../assets/hammerFinish2.svg";
import { ReactComponent as box } from "../../assets/box.svg";

export const MenuElement = (props) => {
    const { anchor, setAnchor } = props;
    const open = Boolean(anchor);

    const isAuth = useUnit($isAuth);

    const handleClose = () => {
        setAnchor(null);
    };

    const goToCompletedBiddings = () => {
        window.location.href = "/completedBiddings";
    };

    const goToRules = () => {
        window.location.href = "/Rules";
    };

    const logout = () => {
        setIsAuth(false);
        setUserData({});
        setUserDataLoaded(false);
        const cookies = new Cookies();
        cookies.remove("token", { path: '/' });
        window.location.href = "/";
    }

    const goToOrders = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }
    }

    const goToFavoritesLots = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }
        window.location.href = "/favoriteBiddings";
    }

    const mobileMenuStyles = {
        '& .MuiPopover-root': {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center'
        },
        '& .MuiPaper-root': {
            position: 'fixed',
            bottom: 0,
            left: '0px !important',
            top: 'auto !important',

            width: '100%',
            maxWidth: '100vw',
            maxHeight: '85vh',
            margin: 0,

            borderRadius: '20px 20px 0px 0px',
        },
        '& .MuiList-root': {
            paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
        },
        '& .MuiMenuItem-root': {
            color: '#727272',
            padding: '14px 16px',
            fontSize: '14px',
            fontWeight: 400,
            borderRadius: '12px',
            '& .MuiTouchRipple-root': {
                color: '#e9e9e9 !important',
            },
        },
        '& .MuiListItemIcon-root': {
            '& svg, & .MuiSvgIcon-root': {
                fontSize: '24px !important',
                width: '24px !important',
                height: '24px !important',
            }
        },
        '&::before': {
            display: 'none',
        }
    };

    return (
        <React.Fragment>
            <SwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={handleClose}
                onOpen={() => { }}
                disableBackdropTransition={false}
                disableDiscovery={false}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: '#00000080',
                        },
                    },
                }}
                sx={mobileMenuStyles}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px 0 6px 0',
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            width: '60px',
                            height: '6px',
                            backgroundColor: '#D9D9D9',
                            borderRadius: '12px',
                        }}
                    />
                </Box>
                <List disablePadding>
                    <MenuItem onClick={goToFavoritesLots}>
                        <ListItemIcon>
                            <StarFilled />
                        </ListItemIcon>
                        Избранные лоты
                    </MenuItem>

                    <MenuItem onClick={goToCompletedBiddings}>
                        <ListItemIcon>
                            <Icon component={hammerFinish}></Icon>
                        </ListItemIcon>
                        Завершенные торги
                    </MenuItem>

                    <MenuItem onClick={goToOrders}>
                        <ListItemIcon>
                            <Icon component={box}></Icon>
                        </ListItemIcon>
                        Заказы
                    </MenuItem>

                    <MenuItem onClick={goToRules}>
                        <ListItemIcon>
                            <ReadFilled />
                        </ListItemIcon>
                        Правила
                    </MenuItem>

                    {isAuth && (
                        <Box
                            sx={{
                                height: '2px',
                                my: 2,
                                mx: 2,
                                backgroundImage: 'linear-gradient(to right, #D9D9D9 20%, #ffffff00 0%)',
                                backgroundPosition: 'bottom',
                                backgroundSize: '10px 2px',
                                backgroundRepeat: 'repeat-x',
                            }}
                        />)}

                    {isAuth && (<MenuItem
                        onClick={() => logout()}
                        sx={{ color: '#CF1322 !important', '&:hover': { backgroundColor: '#d32f2f0a' } }}
                    >
                        <ListItemIcon sx={{ color: '#CF1322 !important' }}>
                            <LogoutOutlined />
                        </ListItemIcon>
                        Выход
                    </MenuItem>)}

                </List>
            </SwipeableDrawer>
        </React.Fragment>
    )
}